import React from "react";
import { Route, withRouter, Redirect } from "react-router-dom";
import { isEmpty } from "lodash";
import { getAccessToken } from "../../apis/auth";
import { isManagerCompany } from "../../utils/auth";

const TaxPortalAuthmiddleware = ({ path, component: Component, layout: Layout }) => {

  return <Route
    path={path}
    render={(props) => {
      // here you can apply condition
      const token = getAccessToken();
      if (isEmpty(token) || !isManagerCompany()) {
        // TODO 자동 로그인 설정
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
};

export default withRouter(TaxPortalAuthmiddleware);
